import React from 'react';
import { dynastyTheme } from '../../services/colorService';

const GameCardGrid = ({ games, onSelectGame }) => {
  if (!games || games.length === 0) {
    return (
      <div className={`p-8 text-center ${dynastyTheme.classes.text.neutralLight}`}>
        No games scheduled today
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 p-4">
      {games.map(game => {
        const isLive = game.status_code === 'I';
        const isFinal = game.status_code === 'F' || game.status_code === 'O';
        const owned = game.owned_players?.length || 0;

        let statusText = game.game_time || 'TBD';
        let statusColor = dynastyTheme.classes.text.white;
        if (isLive) {
          const half = game.inning_state === 'Top' ? 'Top' : 'Bot';
          statusText = `${half} ${game.inning}`;
          statusColor = dynastyTheme.classes.text.success;
        } else if (isFinal) {
          statusText = 'Final';
          statusColor = dynastyTheme.classes.text.neutralLight;
        }

        return (
          <button
            key={game.game_pk}
            onClick={() => onSelectGame(game.game_pk)}
            className={`${dynastyTheme.components.card.base} p-3 text-left hover:ring-1 hover:ring-yellow-400/40 transition-all cursor-pointer`}
          >
            {/* Score header */}
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-3">
                <div className="text-center min-w-[36px]">
                  <div className={`text-xs font-bold ${dynastyTheme.classes.text.white}`}>{game.away_team}</div>
                  <div className={`text-lg font-bold ${dynastyTheme.classes.text.white}`}>{isFinal || isLive ? game.away_score : ''}</div>
                </div>
                <span className={`text-xs ${dynastyTheme.classes.text.neutralLight}`}>@</span>
                <div className="text-center min-w-[36px]">
                  <div className={`text-xs font-bold ${dynastyTheme.classes.text.white}`}>{game.home_team}</div>
                  <div className={`text-lg font-bold ${dynastyTheme.classes.text.white}`}>{isFinal || isLive ? game.home_score : ''}</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {isLive && <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>}
                <span className={`text-xs font-semibold ${statusColor}`}>{statusText}</span>
              </div>
            </div>

            {/* Owned players count */}
            {owned > 0 && (
              <div className={`text-[10px] ${dynastyTheme.classes.text.neutralLight} border-t ${dynastyTheme.classes.border.neutral} pt-1.5 mt-1`}>
                <span className={`font-semibold ${dynastyTheme.classes.text.primary}`}>{owned}</span> league player{owned !== 1 ? 's' : ''} in this game
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default GameCardGrid;
